import { atom } from 'recoil';

/**
 * Último orçamento para o qual o estado de pagamento da tela foi preparado. Serve para
 * saber que o checkout aberto agora é de outra compra, e não a mesma tela remontando.
 */
export const preparedBudgetIdAtom = atom<number | null>({
  key: 'preparedBudgetIdAtom',
  default: null,
});
